import { QueryClient, useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';

import {
  DOWNLOAD_SONG_API,
  DOWNLOAD_SONG_QUERY_KEY,
  PREVIEW_MUSIC_API_URL,
  PREVIEW_MUSIC_QUERY_KEY,
  SEARCH_MUSIC_API_URL,
  SEARCH_MUSIC_QUERY_KEY
} from '@/constants';
import { apiUrl, getQueryParams } from '@/helpers';
import { ErrorResponse, Options } from '@/types';
import { DownloadSong } from '@/types/MusicType';

export const musicEndpoints = {
  searchMusic: (search: string) => {
    return axios.get(
      `${apiUrl()}${SEARCH_MUSIC_API_URL}${getQueryParams({
        search: search
      })}`
    );
  },
  previewMusic: (songId: number) =>
    axios.post(
      `${apiUrl()}${PREVIEW_MUSIC_API_URL}${getQueryParams({
        songId: songId
      })}`
    ),
  downloadSong: ({ payload }: { payload: DownloadSong }) =>
    axios.post(`${apiUrl()}${DOWNLOAD_SONG_API}`, payload)
};

export const useSearchMusicQuery = (search: string, enabled = true) => {
  return useQuery([SEARCH_MUSIC_QUERY_KEY, search], () => musicEndpoints.searchMusic(search), {
    keepPreviousData: false,
    cacheTime: 1000,
    staleTime: 0,
    enabled
  });
};

export const usePreviewMusicQuery = (songId: number) => {
  return useQuery(
    [PREVIEW_MUSIC_QUERY_KEY, { songId }],
    () => musicEndpoints.previewMusic(songId),
    {
      keepPreviousData: true,
      cacheTime: 1000,
      enabled: false
    }
  );
};

export const useDownloadSongMutation = (queryClient: QueryClient, options: Options) => {
  return useMutation(musicEndpoints.downloadSong, {
    onSuccess: (response) => {
      options.onSuccess(response);
      queryClient.invalidateQueries([DOWNLOAD_SONG_QUERY_KEY]);
    },
    onError: (error) => {
      options.onError(error as ErrorResponse);
    }
  });
};
